import { error, finish } from '../../../modules/related-contingency/actions/get-event-info';
import api from '../../../api';

export function request(dispatch, { eventId, tagId }) {
    api.get(`/contingencies/tag-content/tag-info/${tagId}/${eventId}`)
        .then(res => {
            dispatch(finish(res));
        }).catch(err => {
            dispatch(error(err));
        });
}
